// extracted by mini-css-extract-plugin
module.exports = {"cautionBlock":"CautionBlock_cautionBlock__h7BkZ"};